import { authActions } from 'store/auth'
import { createBrowserClient } from '@p22-supabase/browser'
import { Database } from 'types/database'
import { forget as forgetSpace } from 'services/spaces'
import { removeUserFromScope } from 'sentry'
import { store } from 'store'
import { unsafeFlushSWRCache } from 'utils/flushSWRCache'

const dispatch = store.dispatch

export const supabase = createBrowserClient<Database>()

if (typeof window !== 'undefined') {
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_IN') {
      dispatch(authActions.userSignedIn(session))
    }

    if (event === 'TOKEN_REFRESHED') {
      dispatch(authActions.userTokenRefreshed(session))
    }

    if (event === 'SIGNED_OUT') {
      dispatch(authActions.userSignedOut())
      unsafeFlushSWRCache()
      forgetSpace()
      removeUserFromScope()
    }

    if (event === 'USER_UPDATED') {
      dispatch(authActions.userInfoUpdated(session))
    }
  })
}
